document.addEventListener('DOMContentLoaded', function () {
  infiniteScroll();
});
function infiniteScroll() {
  const endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#Huratips-Pagination',
    callback: function () {
      hideDuplicatePromos();
      handleSwiper();
    }
  });
}
function hideDuplicatePromos() {
  const seenPromos = {
    promo_coloum1: false,
    promo_coloum2: false,
    promo_coloum3: false
  };
  document.querySelectorAll('.promotional-block-main').forEach(function (element) {
    const promoClass = element.className.split(' ').find((cls) => seenPromos.hasOwnProperty(cls));
    if (promoClass) {
      if (seenPromos[promoClass]) {
        element.classList.add('hide');
      } else {
        seenPromos[promoClass] = true;
      }
    }
  });
}

const sortOptions = document.querySelectorAll('.cust_sortby .sort-option');
sortOptions.forEach(function (option) {
  option.addEventListener('click', function () {
    sortOptions.forEach(function (opt) {
      opt.classList.remove('active');
    });
    option.classList.add('active');
    document.getElementById('SortBy-mobile').value = this.getAttribute('value');
    if (document.getElementById('SortBy-mobile')) {
      if (typeof Shopify.queryParams !== 'object' || Shopify.queryParams === null) {
        Shopify.queryParams = {};
      }
      Shopify.queryParams.sort_by = document.getElementById('SortBy-mobile').value;
      updateProductListing(Shopify.queryParams);
    }
  });
});

function updateProductListing(params) {
  const url = new URL(window.location.href);
  Object.keys(params).forEach((key) => url.searchParams.set(key, params[key]));
  history.replaceState(null, '', url);
  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      document.getElementById('product-grid').innerHTML = doc.getElementById('product-grid').innerHTML;
      Shopify.cardProductSlider('.prod-images-slider');
      if (doc.getElementById('Huratips-Pagination')) {
        document.getElementById('Huratips-Pagination').innerHTML = doc.getElementById('Huratips-Pagination').innerHTML;
      }
    })
    .catch((error) => console.error('Error fetching the sorted content:', error));
}
document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector('.mobile_sort_description').scrollHeight > document.querySelector('.mobile_sort_description').clientHeight) {
    document.querySelector('.readmore').style.display = 'block';
  }
});